import Vue from 'vue'
import Router from 'vue-router'
import SelectTechnology from './views/SelectTechnology.vue'
import SelectArchitectures from './views/SelectArchitectures.vue'
import AppDetails from './views/AppDetails.vue'
import GenerateApp from './views/GenerateApp.vue'
import Login from './views/Login.vue'
import SignUp from './views/SignUp.vue'
import Dashboard from './views/Dashboard.vue'
import Landing from './views/Landing.vue'
import firebase from 'firebase'



const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/landing',
      name: 'landing',
      component: Landing
    },
    {
      path: '/sign-up',
      name: 'sign-up',
      component: SignUp
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/select-technology',
      name: 'select-technology',
      component: SelectTechnology,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/select-architectures',
      name: 'select-architectures',
      component: SelectArchitectures,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/app-details',
      name: 'app-details',
      component: AppDetails,
      meta: {
        requiresAuth: true
      }
    },
    
    {
      path: '/generate-app',
      name: 'generate-app',
      component: GenerateApp,
      meta: {
        requiresAuth: true
      }
    },
  ]
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  var showLogin = requiresAuth && !currentUser;
  var showAuthorizedView = !requiresAuth && currentUser;

  // console.log('Navigate to: ' + to.fullPath + ' from: ' + from.fullPath);

  // When navigating back frm the generate app view we want to go to the dashboard and not the 
  // app details view again? or what
  // if(to.fullPath == '/app-details' && from.fullPath == '/generate-app') {
  //   next('/');
  // }
  
  // console.log('showAuthorizedView: ' + JSON.stringify(showAuthorizedView));
  // console.log('showLogin: ' + showLogin + ' requiresAuth: ' + requiresAuth + ' currentUser: ' + currentUser);
  if(showLogin) {
    var potentialToRoute = '/landing';
    if(potentialToRoute != to.fullPath) {
      next(potentialToRoute);
    }
  } else if (showAuthorizedView) {
    next('/');
  } else {
    next();
  }
});

export default router;
